import {
  Home,
  MessageSquare,
  Settings as SettingsIcon,
  User,
  Lock,
  CreditCard,
  Users,
  Building2,
  Brain,
  Blocks,
  ShieldCheck,
} from 'lucide-react'
import type { StaticSearchItem } from '../types'

// Mirrors the nav items in components/ui/sidebar.tsx.
const PAGES: StaticSearchItem[] = [
  { id: 'page-home', category: 'Pages', title: 'Dashboard', icon: Home, href: '/dashboard' },
  { id: 'page-chat', category: 'Pages', title: 'Chat', icon: MessageSquare, href: '/dashboard/chat' },
  { id: 'page-settings', category: 'Pages', title: 'Settings', icon: SettingsIcon, href: '/dashboard/settings' },
]

// Mirrors the `sections` list in pages/SettingsPage.tsx (id/label/icon), plus
// `keywords` so e.g. typing "hubspot" surfaces Integrations. The settings page
// itself already redirects a role that can't see a given tab back to Profile,
// so no role gating is duplicated here.
const SETTINGS: StaticSearchItem[] = [
  {
    id: 'profile',
    category: 'Settings',
    title: 'Personal Info',
    subtitle: 'Your personal information visible to your workspace.',
    icon: User,
    href: '/dashboard/settings?tab=profile',
    keywords: ['account', 'name', 'avatar', 'email'],
  },
  {
    id: 'password',
    category: 'Settings',
    title: 'Password',
    subtitle: 'Update your login password.',
    icon: Lock,
    href: '/dashboard/settings?tab=password',
    keywords: ['security', 'login'],
  },
  {
    id: 'billing',
    category: 'Settings',
    title: 'Billing',
    subtitle: 'Manage your plan and payment details.',
    icon: CreditCard,
    href: '/dashboard/settings?tab=billing',
    keywords: ['plan', 'payment', 'subscription', 'invoice', 'upgrade'],
  },
  {
    id: 'workspace',
    category: 'Settings',
    title: 'Workspace',
    subtitle: 'Manage your workspace details and team.',
    icon: Users,
    href: '/dashboard/settings?tab=workspace',
    keywords: ['team', 'members', 'invite', 'seats'],
  },
  {
    id: 'company-profile',
    category: 'Settings',
    title: 'Company Profile',
    subtitle: 'Identity & positioning Zeph uses for research, qualification, and outreach.',
    icon: Building2,
    href: '/dashboard/settings?tab=company-profile',
    keywords: ['identity', 'positioning', 'product', 'value proposition', 'icp', 'differentiators', 'competitors'],
  },
  {
    id: 'memory',
    category: 'Settings',
    title: 'Memory',
    subtitle: 'Control what Zeph remembers and reuses across conversations.',
    icon: Brain,
    href: '/dashboard/settings?tab=memory',
    keywords: ['remember', 'facts', 'recall', 'forget'],
  },
  {
    id: 'communication-guidelines',
    category: 'Settings',
    title: 'Communication Guidelines',
    subtitle: 'Brand voice, example emails, objection playbook, and follow-up cadence Zeph uses for outreach.',
    icon: MessageSquare,
    href: '/dashboard/settings?tab=communication-guidelines',
    keywords: ['brand voice', 'email templates', 'objection', 'follow-up', 'cadence', 'tone'],
  },
  {
    id: 'integrations',
    category: 'Settings',
    title: 'Integrations',
    subtitle: 'Connect external tools to enhance your Zeph AI workspace.',
    icon: Blocks,
    href: '/dashboard/settings?tab=integrations',
    keywords: ['hubspot', 'pipedrive', 'salesforce', 'slack', 'gmail', 'outlook', 'teams', 'zoom', 'google meet', 'crm', 'calendar', 'connect'],
  },
  {
    id: 'permissions',
    category: 'Settings',
    title: 'Permissions',
    subtitle: 'Control what Zeph is allowed to do on its own in your CRM and email.',
    icon: ShieldCheck,
    href: '/dashboard/settings?tab=permissions',
    keywords: ['ai permissions', 'auto-pilot', 'approval', 'guardrails'],
  },
]

export const STATIC_SEARCH_ITEMS: StaticSearchItem[] = [...PAGES, ...SETTINGS]
